module.exports = __webpack_public_path__ + "img/vertical_7_3_0.c14aeb6f.png";